<div class="page-layout simple fullwidth" fusePerfectScrollbar>
  @if (page$ | async; as page) {
    <h1>{{page.get('label')}}</h1>
    <app-tips [label]="'basic_page_cards.' + (page.get('label') | snakeCase) | translate"></app-tips>
    <div class="card-grid">
      @for (card of page.get('pages'); track card; let index = $index) {
        <mat-card>
          <mat-card-header>
            <mat-card-title>{{card.label}}</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="image-content">
              <img mat-card-image [src]="getImageSrc(index)" [alt]="card.label">
            </div>
            <div class="body-wrapper">
              <div class="body-content" [innerHTML]="card.body"></div>
              <div class="inside-actions">
                @if (!!downloadDocumentLink(card)) {
                  <a
                    [href]="downloadDocumentLink(card)"
                    target="_blank"
                  mat-raised-button>{{'generic.download' | translate}}</a>
                }
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      }
    </div>
  } @else {
    <mat-spinner></mat-spinner>
  }
</div>


